import request from '@/utils/request';
import type { PaginatedParams } from 'ahooks/lib/useAntdTable';

export type PwdProps = {
  "oldPwd": string;
  "newPwd": string;
  "loginName": string;
}

export function getRoleList(): Promise<any> {
  return request('/sys/role/allList', {
    method: 'POST',
  });
}


export function roleListGet({ current, pageSize }: PaginatedParams[0], formData: object): Promise<any> {
  const targetParams = { pageNum: current, pageSize,...formData };
  return request('/sys/role/list', {
    method: 'POST',
    data: targetParams
  });
}

export type RoleAddOrUpdateProps = {
  name: string;
  remarks: string;
  resourceIds: string[];
  id?: string
}
export function roleAdd(data: RoleAddOrUpdateProps): Promise<any> {
  return request('/sys/role/add', {
    method: 'POST',
    data
  });
}

export function roleUpdate(data: RoleAddOrUpdateProps): Promise<any> {
  return request('/sys/role/update', {
    method: 'POST',
    data
  });
}

export function roleDelete(data: { id: string }): Promise<any> {
  return request('/sys/role/delete', {
    method: 'POST',
    data
  });
}

export function roleGet(data: { id: string }): Promise<any> {
  return request('/sys/role/get', {
    method: 'POST',
    data: { id: data }
  });
}

export function findUserByRole(data: { id: string }): Promise<any> {
  return request('/sys/role/findUserByRole', {
    method: 'POST',
    data
  });
}

export function getUserListByRole({ current, pageSize }: PaginatedParams[0], formData: object): Promise<any> {
  const targetParams = { pageNum: current, pageSize,...formData };
  return request('/sys/role/getUserListByRole', {
    method: 'POST',
    data:targetParams
  });
}


export function deleteRoleUser(data: { userId: string,roleId: string }): Promise<any> {
  return request('/sys/role/deleteRoleUser', {
    method: 'POST',
    data
  });
}










